import React, { useState, useEffect } from 'react';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
// import myPDF from "./report1.pdf";
import fontTHSarabunNew from '../../../../THSarabunNew.ttf';
import fontkit from '@pdf-lib/fontkit';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
import data from '../EmploymentPage/PersonProperties';
// import fs from 'fs';
import {
  formatDateTH,
  formatDateTHYYYY,
  formatTHMMM,
} from '../../../../common/DateUtils';
import dataProperties from '../EmploymentPage/PersonProperties';
import { drawImageOnPdf } from './drawSign';

//from R4Frame.js

//ต้นฉบับจาก R4v2.js, 23-03-14
function R4v2() {
  const [pdfUrl, setPdfUrl] = useState('');
  const [param1, setParam1] = useState('');
  const [employee, setEmployee] = useState('');
  const [loading, setLoading] = useState(false);

  //รูปลายเซ็น - ไม่จำเป็นต้องใช้ state เหล่านี้แล้ว เพราะจัดการใน getEmployee
  // const [sign, setSign] = useState('');
  // const [hrSign, setHrSign] = useState('');
  // const [signImg, setSignImg] = useState('');
  // const [hrSignImg, setHrSignImg] = useState('');

  const { user: currentUser } = useSelector((state) => state.auth);

  //หัวหน้ากองสรรหา
  const { hrChief } = data;

  const getEmployee = async (uid) => {
    console.log('--R4v2.js--getEmployee--1');
    setLoading(true);
    try {
      const { data } = await axios.get('/api/cis/employee/uid', {
        params: { id: uid },
      });

      console.log('--R4v2.js--getEmployee--2');
      console.log(data);

      // ดึงลายเซ็นทั้งสามแบบพร้อมกัน
      const signData = await getSignature(data?.emp?.idCard);
      const hrSignData = await getSignature(data?.forReportAdded2?.hrEmpNo);
      const hrChiefSignData = await getSignature(hrChief?.empNo);

      // แปลงเป็น base64 image URL
      let signImgUrl = '';
      let hrSignImgUrl = '';
      let hrChiefSignImgUrl = '';

      if (signData) {
        const buffer = Buffer.from(signData, 'base64');
        signImgUrl = `data:image/png;base64,${buffer.toString('base64')}`;
      }

      if (hrSignData) {
        const buffer = Buffer.from(hrSignData, 'base64');
        hrSignImgUrl = `data:image/png;base64,${buffer.toString('base64')}`;
      }

      if (hrChiefSignData) {
        const buffer = Buffer.from(hrChiefSignData, 'base64');
        hrChiefSignImgUrl = `data:image/png;base64,${buffer.toString(
          'base64'
        )}`;
      }

      // set employee พร้อมกับ signature images ในครั้งเดียว
      setEmployee({
        ...data,
        signImg: signImgUrl,
        hrSignImg: hrSignImgUrl,
        hrChiefSignImg: hrChiefSignImgUrl,
      });
    } catch (error) {
      console.log(error.response);
    } finally {
      setLoading(false);
    }
  };

  const getSignature = async (idCard) => {
    console.log('--R3v2.js--getSignature--1');
    try {
      const { data } = await axios.get(`/api/signupload/${idCard}`);
      console.log('--R3v2.js--getSignature--2', data);
      return data?.data;
    } catch (error) {
      console.log(error.response);
    }
  };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        setTimeout(() => {
          console.log(res);
        }, 400);
      });
  };

  var BASE64_MARKER = ';base64,';

  function convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  // ลบ useEffect ที่ไม่จำเป็นออก เพราะจัดการใน getEmployee แล้ว

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const uid = queryParams.get('id');
    console.log('--R1v2.js--uid--', uid);
    getEmployee(uid);
    // getDataFromAPI();
  }, []);

  useEffect(() => {
    const loadPdf = async () => {
      const url = '/app/document4v2.pdf';
      const existingPdfBytes = await fetch(url).then((res) =>
        res.arrayBuffer()
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.registerFontkit(fontkit);

      const fontBytes = await fetch(fontTHSarabunNew).then((res) =>
        res.arrayBuffer()
      );
      const myFont = await pdfDoc.embedFont(fontBytes, { subset: true });

      console.log('----R4v2---loadPdf----', employee?.emp?.firstName);

      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      const { width, height } = firstPage.getSize();

      console.log('-----width, height------', width, height);

      //สัญญาฉบับนี้ทำที่ กฟผ.
      firstPage.drawText(`กฟผ.`, {
        x: 278,
        // y: 841 - 150,
        y: 791 - 115,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //โดย ชื่อ-นามสกุล
      if (employee?.empHead?.PS_TName) {
        const hName = employee.empHead.PS_TName;
        const hSurname = employee.empHead.PS_TLastName;
        const prefix = employee.empHead.PS_TPrefixName;
        const fullName = prefix + hName + ' ' + hSurname;
        firstPage.drawText(`${fullName}`, {
          x: 359,
          y: 791 - 135,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ตำแหน่ง
      if (employee?.empHead?.ORG_TLongName) {
        // let pName = employee.empHead.ORG_TLongName;
        const division = employee.empHead.ORG_TShortName;
        // if (division.substring(0, 1) == 'อ') pName = 'ผู้อำนวยการ' + pName;
        // const len = pName.length;
        let fontSize = 14;
        //ถ้ายาวมาก จะให้ font เล็กลง
        // if (len > 35) {
        // fontSize = 10;
        // }
        firstPage.drawText(`${division}`, {
          x: 199,
          y: 791 - 155,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ชื่อ - นามสกุล
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;
        // const fullName = fName + ' ' + lName;

        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const start = 131;
        const end = 330;
        const space = end - start;
        const nameLen = fullName.length;
        const rest = space - nameLen;
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(`${fullName}`, {
          x: 121 + restHalf - nameLen,
          y: 791 - 174,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อายุ
      if (!!employee?.emp?.birthdate) {
        const bd = employee.emp.birthdate;
        const birthdate = new Date(bd);
        const ageInMilliseconds = Date.now() - birthdate.getTime();
        const ageInYears = new Date(ageInMilliseconds).getFullYear() - 1970;
        // console.log(ageInYears);

        firstPage.drawText(`${ageInYears}`, {
          x: 362,
          y: 791 - 174,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ที่อยู่ตามทะเบียนบ้าน
      const pAddr1 = employee?.emp?.homeAddress;
      firstPage.drawText(`${pAddr1}`, {
        x: 164,
        y: 791 - 187,
        size: 14,
        font: myFont,
        color: rgb(0, 0, 0.5),
      });

      //ตำบล/แขวง
      if (!!employee?.emp?.homeTambolName) {
        const tambol = employee.emp.homeTambolName;
        firstPage.drawText(`${tambol}`, {
          x: 166,
          y: 791 - 214,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //อำเภอ/เขต
      if (!!employee?.emp?.homeDistrictName) {
        const dist = employee.emp.homeDistrictName;
        firstPage.drawText(`${dist}`, {
          x: 303,
          y: 791 - 214,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //จังหวัด
      if (!!employee?.emp?.homeProvinceName) {
        const prov = employee.emp.homeProvinceName;
        firstPage.drawText(`${prov}`, {
          x: 426,
          y: 791 - 214,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //รหัสไปรษณีย์
      if (!!employee?.emp?.homePostalCode) {
        const post = employee.emp.homePostalCode;
        firstPage.drawText(`${post}`, {
          x: 157,
          y: 791 - 234,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //โทรศัพท์
      if (!!employee?.emp?.mobileNo) {
        const mobile = employee.emp.mobileNo;
        firstPage.drawText(`${mobile}`, {
          x: 274,
          y: 791 - 234,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ปฏิบัติในตำแหน่ง
      if (!!employee?.jobData?.position) {
        const jobPosition = employee.jobData.position;
        const jobLevel = employee.jobData.empLevel;
        const jobFullName = jobPosition + ' ระดับ ' + jobLevel;
        firstPage.drawText(`${jobFullName}`, {
          x: 446,
          y: 793 - 235,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //สังกัดแผนก
      if (!!employee?.forReportAdded2?.empSection) {
        const start = 288;
        const end = 383;
        const space = end - start;
        const empSectionLen = employee?.forReportAdded2?.empSection.length;
        const rest = space - empSectionLen * 8; // ประมาณ 8px ต่อตัวอักษร
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(employee?.forReportAdded2?.empSection, {
          x: start + restHalf,
          y: 538,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //กอง
      if (!!employee?.forReportAdded2?.empDepartment) {
        const start = 402;
        const end = 510;
        const space = end - start;
        const empDepartmentLen =
          employee?.forReportAdded2?.empDepartment.length;
        const rest = space - empDepartmentLen * 8; // ประมาณ 8px ต่อตัวอักษร
        const restHalf = Math.round(rest / 2);

        firstPage.drawText(employee?.forReportAdded2?.empDepartment, {
          x: start + restHalf,
          y: 538,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ฝ่าย
      if (!!employee?.forReportAdded2?.division) {
        let division = employee?.forReportAdded2?.division;
        firstPage.drawText(`${division}`, {
          x: 155,
          y: 791 - 273,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      // if (!!employee?.empDivision) {
      //   const d1 = employee.empDivision.d1;
      //   const d2 = employee.empDivision.d2;
      //   const d3 = employee.empDivision.d2;
      //   let division = d1;
      //   //ถ้าฝ่ายไม่มี เอาช่วย
      //   if (d1 == '-') division = d2;
      //   //ถ้าฝ่ายและช่วยไม่มีเอารอง
      //   if (d1 == '-' && d2 == '-') division = d3;
      //   firstPage.drawText(`${division}`, {
      //     x: 155,
      //     y: 791 - 273,
      //     size: 14,
      //     font: myFont,
      //     color: rgb(0, 0, 0.5),
      //   });
      // }

      //รหัสสังกัด
      if (employee?.forReportAdded2?.orgCode) {
        const org = employee.forReportAdded2.orgCode;
        firstPage.drawText(`${org}`, {
          x: 278,
          y: 791 - 273,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      // const firstPage = pages[1];
      //ลงชื่อ กฟผ.
      if (employee?.empHead?.PS_TName) {
        const hName = employee.empHead.PS_TName;
        const hSurname = employee.empHead.PS_TLastName;
        const prefix = employee.empHead.PS_TPrefixName;
        const fullName = prefix + hName + ' ' + hSurname;
        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)

        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const start = 152;
        const end = 280;
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(`${fullName}`, {
          x: finalX,
          y: 791 - 586,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      if (!!employee?.empHead?.ORG_TLongName) {
        let pName = employee?.empHead?.ORG_TLongName;
        const division = employee?.empHead?.ORG_TShortName;
        if (division.substring(0, 1) == 'อ') pName = 'ผู้อำนวยการ' + pName;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(pName, fontSize);
        const start = 126;
        const end = 300;
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(`${pName}`, {
          x: finalX,
          y: 192,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //ลายเซ็นผู้สมัคร
      if (!!employee?.signImg) {
        try {
          console.log(
            'Drawing signImg (ผู้สมัคร):',
            employee.signImg?.substring(0, 50)
          );
          const startX = 325;
          const startY = 225;
          const image = await pdfDoc.embedPng(employee.signImg);
          console.log('signImg embedded successfully');
          await drawImageOnPdf(image, firstPage, startX, startY);
          console.log('signImg drawn successfully');
        } catch (err) {
          console.error('err signature img (ผู้สมัคร):', err);
        }
      } else {
        console.log('No signImg available for ผู้สมัคร');
      }

      //ลงชื่อ ผู้ปฏิบัติงาน
      //ชื่อ - นามสกุล
      if (!!employee?.emp?.firstName) {
        const title = employee.emp.title;
        let titleNm = '';
        if (title == 1) titleNm = 'นาย';
        if (title == 2) titleNm = 'นาง';
        if (title == 3) titleNm = 'นางสาว';
        const fName = employee.emp.firstName;
        const lName = employee.emp.lastName;
        const fullName = titleNm + fName + ' ' + lName;
        // const fullName = fName + ' ' + lName;

        //จัดให้อยู่กึ่งกลาง
        //1.กำหนดขอบเขต, 2.หาเนื้อที่, 3.เนื้อที่ลบตัวอักษรหารสอง, 4.และลบความยาวตัวอักษรด้วย,
        //5.ได้เนื้อที่ (แต่เป็นภาษาไทย ช่องไฟอาจไม่เท่าภาษาอังกฤษ เลยต้องร่นแกน x เผื่อไว้เองหน่อยนึง)
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);

        const start = 336;
        const end = 464;
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(`${fullName}`, {
          x: finalX,
          y: 791 - 586,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เมื่อวันที่
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        const signDate = new Date(sd);
        firstPage.drawText(`${signDate.getDate()}`, {
          x: 374,
          y: 791 - 115,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เมื่อวันที่ เดือน
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        firstPage.drawText(`${formatTHMMM(sd)}`, {
          x: 422,
          y: 791 - 115,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เมื่อวันที่ พ.ศ.
      if (!!employee?.forReportAdded2?.signDate) {
        const sd = employee.forReportAdded2.signDate;
        firstPage.drawText(`${formatDateTHYYYY(sd)}`, {
          x: 487,
          y: 791 - 115,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เลขประจำตัว
      if (!!employee?.forReportAdded2?.empNo) {
        const empNo = employee.forReportAdded2.empNo;
        firstPage.drawText(`${empNo}`, {
          x: 190,
          y: 791 - 253,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เข้าทำงานที่ กฟผ. วันที่
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        const signDate = new Date(sd);
        firstPage.drawText(`${signDate.getDate()}`, {
          x: 475,
          y: 791 - 273,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เข้าทำงานที่ กฟผ. เดือน
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        firstPage.drawText(`${formatTHMMM(sd)}`, {
          x: 128,
          y: 791 - 293,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //เข้าทำงานที่ กฟผ. พ.ศ.
      if (!!employee?.forReportAdded2?.startWorkDate) {
        const sd = employee.forReportAdded2.startWorkDate;
        firstPage.drawText(`${formatDateTHYYYY(sd)}`, {
          x: 196,
          y: 791 - 293,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      //พยาน hr
      if (!!employee?.forReportAdded2?.hrEmpName) {
        const hrEmpName = employee.forReportAdded2.hrEmpName;

        //จัดให้อยู่กึ่งกลาง
        const start = 342;
        const end = 467;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(hrEmpName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(hrEmpName, {
          x: finalX,
          y: 131,
          size: fontSize,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      //พยาน hr
      if (!!employee?.forReportAdded2?.hrEmpPosition) {
        let hrEmpPosition = employee.forReportAdded2.hrEmpPosition;

        // Decode HTML: แปลง <p>...</p> เป็นบรรทัดใหม่
        hrEmpPosition = hrEmpPosition
          .replace(/<p>/gi, '')
          .replace(/<\/p>/gi, '\n')
          .replace(/&nbsp;/g, ' ')
          .trim();

        // แยกบรรทัด
        const lines = hrEmpPosition.split('\n').filter((line) => line.trim());

        const start = 321;
        const end = 492;
        const fontSize = 13;
        const lineHeight = 11; // ระยะห่างระหว่างบรรทัด

        // วาดแต่ละบรรทัดโดยจัดกึ่งกลาง
        lines.forEach((line, index) => {
          const textWidth = myFont.widthOfTextAtSize(line, fontSize);
          const space = end - start;
          const centerX = start + space / 2;
          const finalX = centerX - textWidth / 2;

          firstPage.drawText(line, {
            x: finalX,
            y: 118 - index * lineHeight, // แต่ละบรรทัดลดลง
            size: fontSize,
            font: myFont,
            color: rgb(0, 0, 0.5),
          });
        });
      }

      //ลายเซ็น HR
      if (!!employee?.hrSignImg) {
        try {
          console.log(
            'Drawing hrSignImg (HR):',
            employee.hrSignImg?.substring(0, 50)
          );
          const startX = 325;
          const startY = 151;
          const image = await pdfDoc.embedPng(employee.hrSignImg);
          console.log('hrSignImg embedded successfully');
          await drawImageOnPdf(image, firstPage, startX, startY);
          console.log('hrSignImg drawn successfully');
        } catch (err) {
          console.error('err hr signature img:', err);
        }
      } else {
        console.log('No hrSignImg available for HR');
      }

      //ลายเซ็นหัวหน้ากองสรรหา
      if (!!employee?.hrChiefSignImg) {
        try {
          console.log(
            'Drawing hrChiefSignImg (HR Chief):',
            employee.hrChiefSignImg?.substring(0, 50)
          );
          const startX = -40;
          const startY = 151;
          const image = await pdfDoc.embedPng(employee.hrChiefSignImg);
          console.log('hrChiefSignImg embedded successfully');
          await drawImageOnPdf(image, firstPage, startX, startY);
          console.log('hrChiefSignImg drawn successfully');
        } catch (err) {
          console.error('err hr chief signature img:', err);
        }
      } else {
        console.log('No hrChiefSignImg available for HR Chief');
      }

      if (hrChief?.empName) {
        const fullName = hrChief?.empName;
        const start = 154;
        const end = 281;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(fullName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;

        firstPage.drawText(`${fullName}`, {
          x: finalX,
          y: 131,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }
      if (!!hrChief?.position) {
        //จัดให้อยู่กึ่งกลาง - ตำแหน่ง
        let pName = hrChief.position;
        const start = 154;
        const end = 281;
        const fontSize = 14;

        // คำนวณความกว้างของข้อความจริง
        const textWidth = myFont.widthOfTextAtSize(pName, fontSize);
        const space = end - start;
        const centerX = start + space / 2;
        const finalX = centerX - textWidth / 2;
        firstPage.drawText(`${pName}`, {
          x: finalX,
          y: 118,
          size: 14,
          font: myFont,
          color: rgb(0, 0, 0.5),
        });
      }

      const pdfBytes = await pdfDoc.save();
      const pdfUrl = URL.createObjectURL(
        new Blob([pdfBytes], { type: 'application/pdf' })
      );
      setPdfUrl(pdfUrl);

      // setPdfUrl("/app/document1.pdf");
      // setPdfUrl("https://pdf-lib.js.org/assets/with_update_sections.pdf");
    };
    loadPdf();
  }, [employee]);

  // https://dev.to/collegewap/fix-react-hook-useeffect-is-called-conditionally-25m5

  if (!currentUser) {
    return <Navigate to="/app/login" />;
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div>
      {pdfUrl && (
        <iframe src={pdfUrl} width="100%" height="800px" title="PDF Viewer" />
      )}
    </div>
  );
}

export default R4v2;
